<div [ngClass]="{'tdo-calender-view-day': selectedViewOption=='1' || selectedViewOption=='2', 'tdo-calender-view-week': selectedViewOption=='3' || selectedViewOption=='4', 'tdo-calender-view-month': selectedViewOption=='5',}" style="overflow: hidden !important; height: 100dvh; width: 100vw;" data-cy="scheduler-container">
  <table class="sch-table" data-cy="scheduler-header-table">
    <tr class="sch-table-row">
      <td class="sch-table-cell sch-table-cell-date" data-cy="scheduler-date-cell">

        <dx-date-box style="margin-left: 45px;margin-right: 45px; height: 26px" data-cy="scheduler-date"
          type="date"
          displayFormat="MM/dd/yyyy, EEE"
          [value]="tdoCurrentDate"
          (onValueChanged)="onDateChange($event)">
          >
        </dx-date-box>

      </td>
      <td rowspan="2" class="sch-table-cell sch-table-cell-loc" data-cy="scheduler-locations-cell">
        Locations:
        <dx-tag-box
          [dataSource]="praticeLocations"
          valueExpr="LOCID"
          displayExpr="Name"
          [(value)]="selectedLocationsIDs"
          [showSelectionControls]="true"
          applyValueMode="useButtons"
          [multiline]="false"
          tagTemplate="tagTemplate"
          (onClosed)="onLocationClose($event)"
          data-cy="scheduler-locations-tagbox"
          >

          <div *dxTemplate="let data of 'tagTemplate'" data-cy="scheduler-location-tag">
            <div class="tagStyle">
              <span data-cy="scheduler-location-tag-name"> {{ data.Name }}({{data.LocationShortName}})   </span>
              <lucide-icon name="x-circle" [size]="20" class="tagRemoveButton" (click)="removeLOCTag(data)" data-cy="scheduler-location-tag-remove"></lucide-icon>
            </div>
          </div>

        </dx-tag-box>
      </td>
      <td rowspan="2" class="sch-table-cell sch-table-cell-op-filtr" data-cy="scheduler-operatories-cell">
        Operatories to show:

        <dx-tag-box
          [dataSource]="practiceOperatoriesShow"
          valueExpr="OperatoryId"
          displayExpr= "LocAndOpName"
          [multiline]="false"
          [showSelectionControls]="true"
          applyValueMode="useButtons"
          [(value)]="practiceOperatoriesShowFilterIDs"
          tagTemplate="tagTemplateOrg"
          (onClosed)="onpracticeOperatoriesFilterChange($event)"
          data-cy="scheduler-operatories-tagbox"
          >

          <div *dxTemplate="let data of 'tagTemplateOrg'" data-cy="scheduler-operatory-tag">
            <div class="tagStyle">
              <span data-cy="scheduler-operatory-tag-name">{{data.LocationShortName}}-{{ data.OperatoryName }}   </span>
              <lucide-icon name="x-circle" [size]="20" class="tagRemoveButton" (click)="removeOpTag(data)" data-cy="scheduler-operatory-tag-remove"></lucide-icon>
            </div>
          </div>

        </dx-tag-box>

      </td>
      <td rowspan="2" class="sch-table-cell sch-table-cell-views" data-cy="scheduler-views-cell">

        <button mat-raised-button style="width: 90%" [matMenuTriggerFor]="menu" data-cy="scheduler-view-button">{{ viewTypeButtonCaption }}</button>
        <mat-menu #menu="matMenu" data-cy="scheduler-view-menu">
          <button mat-menu-item (click)="btnViewTypeClicked($event,'1')" data-cy="scheduler-view-std">Standard View</button>
          <button mat-menu-item (click)="btnViewTypeClicked($event,'2')" data-cy="scheduler-view-day">Day Detail View</button>
          <button mat-menu-item (click)="btnViewTypeClicked($event,'3')" data-cy="scheduler-view-week">Week View</button>
          <button mat-menu-item (click)="btnViewTypeClicked($event,'4')" data-cy="scheduler-view-work">Work Week View</button>
          <button mat-menu-item (click)="btnViewTypeClicked($event,'5')" data-cy="scheduler-month">Month View</button>
        </mat-menu>

      </td>
      <td rowspan="2" data-cy="scheduler-waitlist-cell">

        <div style="float: right; padding-right: 10px; width: 200px" data-cy="scheduler-waitlist-container">
          <div style="display: flex;  justify-content: center;  align-items: center;" data-cy="scheduler-waitlist-button-container">
            <dx-button
              text="Wait List"
              icon="bulletlist"
              (onClick)="onOpenWaitListComponent()"
              data-cy="scheduler-waitlist-button"
              >
            </dx-button>
            <div matTooltip="Toggle privacy" matTooltipPosition="right" style="cursor: pointer; height: 26px; margin-right: auto; margin-left: auto;" (click)="onPrivacyClick()" data-cy="home-privacy-toggle">
              <span style="position: relative; color: var(--tdo-primary-accent);" data-cy="home-privacy-off">@if (!isPrivateInfoVisible) {
                <lucide-icon name="eye-off" [size]="20"></lucide-icon>
              }</span>
              <span style="position: relative; color: var(--tdo-primary-accent);" data-cy="home-privacy-on">@if (isPrivateInfoVisible) {
                <lucide-icon name="eye" [size]="20"></lucide-icon>
              }</span>
            </div>
          </div>
          <div style=" justify-content: center; align-items: center; margin-top: 4px; gap: 8px;" data-cy="scheduler-close-on-open-patient-container">
            <mat-checkbox [(ngModel)]="closeWhenOpeningPatient" data-cy="scheduler-close-on-open-patient-checkbox" style="font-size: 12px;">Close when opening patient</mat-checkbox>
            <span style="font-size: 12px;">Reload:
              <select [(ngModel)]="autoReloadIntervalMinutes" data-cy="scheduler-auto-reload-select" style="font-size: 12px; padding: 2px 4px;" title="Automatically reload appointments at the chosen interval">
                @for (opt of autoReloadOptions; track opt.value) {
                  <option [ngValue]="opt.value">{{opt.label}}</option>
                }
              </select>
            </span>
          </div>
          @if (this.globals.RescheduleAppointmentRequest) {
            <div style="display: flex;  justify-content: center;  align-items: center;" data-cy="scheduler-reschedule-container">
              <span style="font-size:x-small" data-cy="scheduler-reschedule-name">Reschedule: {{this.globals.RescheduleAppointmentRequest.Patient_FullName}}</span>
              <dx-button
                icon="clear"
                type="success"
                (onClick)="onClickClearReschedule()"
              data-cy="scheduler-reschedule-clear"></dx-button>
            </div>
          }
        </div>

      </td>

    </tr>

    <tr class="sch-table-row">
      <td class="sch-table-cell sch-table-cell-date" data-cy="scheduler-navigation-cell">

        <div data-cy="scheduler-navigation-container">
          <mat-icon class="sch-cal-nav" (click)="goToPreviousMonth()" matTooltip='Previous Month' data-cy="scheduler-date-prev-month">skip_previous</mat-icon>
          <lucide-icon name="chevrons-left" [size]="20" class="sch-cal-nav" (click)="goToPreviousWeek()" matTooltip='Previous Week' data-cy="scheduler-date-prev-week"></lucide-icon>
          <lucide-icon name="chevron-left" [size]="20" class="sch-cal-nav" (click)="goToPreviousDay()" matTooltip='Previous Day' data-cy="scheduler-date-prev-day"></lucide-icon>

          <button mat-button color="primary" style="margin-top: -15px" (click)="goToToday()" matTooltip="Go To Today's Date" data-cy="scheduler-date-today">
            Today
          </button>

          <lucide-icon name="chevron-right" [size]="20" class="sch-cal-nav" (click)="goToNextDay()" matTooltip='Next Day' data-cy="scheduler-date-next-day"></lucide-icon>
          <lucide-icon name="chevrons-right" [size]="20" class="sch-cal-nav" (click)="goToNextWeek()" matTooltip='Next Week' data-cy="scheduler-date-next-week"></lucide-icon>
          <mat-icon class="sch-cal-nav" (click)="goToNextMonth()" matTooltip='Next Month' data-cy="scheduler-date-next-month">skip_next</mat-icon>
        </div>
      </td>

    </tr>
  </table>


  <div style="max-height: calc(100dvh - 150px); overflow-y: auto;">

    @if (workDayHourStyles.length > 0) {
      <dx-scheduler #tdoScheduler
        [showAllDayPanel]="false"
        [dataSource]="appointmentsInRangeToShow"
        [groups]="['OperatoryId']"
        resourceCellTemplate="operatoryTemplate"
        [views]="['day', 'week', 'workWeek', 'month']"
        [currentView]="viewType"
        [startDayHour]="visibleStartHour" [endDayHour]="visibleEndHour" [cellDuration]="cellDuration"
        [showCurrentTimeIndicator]='true'
        [currentDate]="tdoCurrentDate"
        [scrolling]="{ mode: 'virtual' }"
        [crossScrollingEnabled]="false"
        [height]="schedulerHeight" [width]="'100%'"
        startDateExpr="parsedStartDate"
        endDateExpr="parsedEndDate"
        dataCellTemplate="dateCellTemplate"
        appointmentTemplate="TDOAppointmentTemplate"
        appointmentTooltipTemplate="TDOAppointmentTooltip_Template"
        (onAppointmentDblClick)="overrideDefaultPopup($event)"
        (mousedown)="onMouseDown($event)" 
        (mousemove)="onMouseMove($event)" 
        (mouseup)="onMouseUp($event)"
        (onCellClick)="onCellClick($event);"
        (onAppointmentClick)="onAppointmentClick($event)"
        (onOptionChanged)="onOptionChanged($event)"
        (onContentReady)="onContentReadyTDOScheduler($event)"
        (onAppointmentUpdated)="onAppointmentUpdated($event)"
        (onAppointmentContextMenu)="onAppointmentContext($event)"
        (selectedCellDataChange)="onSelectedCellDataChange($event)"
        (onAppointmentUpdating)="onAppointmentUpdating($event)"
        data-cy="scheduler-component"
        >
        <dxo-editing [allowAdding]="false" [allowDragging]="true" ></dxo-editing>
        <dxi-resource fieldExpr="OperatoryId"
          valueExpr="OperatoryId"
          displayExpr="OperatoryName"
          [dataSource]="practiceOperatoriesShowFilter"
          data-cy="scheduler-resource">
        </dxi-resource>
        <div *dxTemplate="let dataCell of 'dateCellTemplate'" style="height: 100%; width: 100%; margin: 0; padding: 0;">
          @if (workDayHourStyles.length > 0) {
            <div    [ngStyle]="getCellClass(dataCell)"
              style="height: 100%; width: 100%; margin: 0; padding: 0; box-sizing: border-box; display: flex; align-items: center; justify-content: center;">
              {{emptyCellContent}}
            </div>
          }
        </div>
        <div *dxTemplate="let op of 'operatoryTemplate'" data-cy="scheduler-operatory-template">
          <div [ngStyle]="{'backgroundColor': op.data.color != null ? op.data.color : 'var(--tdo-primary-accent'}"
            [style.width.pct]="100" data-cy="scheduler-operatory">
            <div class="calendar-column-header-text" style="color: white; font-size: 10px;" data-cy="scheduler-operatory-header">
              <div [matTooltip]="op.data.OperatoryDescription" data-cy="scheduler-operatory-name">{{op.data.LocAndOpName}}</div>
            </div>
          </div>
        </div>
        <div *dxTemplate="let app of 'TDOAppointmentTooltip_Template'" [innerHTML]="getAppointmentTooltip(app.appointmentData)" data-cy="scheduler-appointment-tooltip" class="scheduler-appointment-tooltip"></div>
        <div *dxTemplate="let app of 'TDOAppointmentTemplate'"
          [style.background-color]="app.appointmentData?.AppointmentReason_BackColor" [style.color]="app.appointmentData?.AppointmentReason_ForeColor"
          [style.padding-top]="0" [style.padding-left]="0" [style.padding-right]="0"
          data-cy="scheduler-appointment" class="scheduler-appointment">
          @if (app.appointmentData.isBlockTime) {
              <div
                style="width: 100%; text-align: center; font-weight: 600; align-content: center; height: 100%"
                data-cy="scheduler-appointment-reserved-text"
                >
                {{app.appointmentData.Description}}
              </div>
          }
          @if (app.appointmentData.isReservation) {
            <div
              style="pointer-events: none; background-color: var(--tdo-primary); color: white; position: relative; width: 100%;"
              data-cy="scheduler-appointment-reserved">
              <div
                style="width: 100%; text-align: center; font-weight: 500;"
                data-cy="scheduler-appointment-reserved-text">
                RESERVED
              </div>
            </div>
          }
          @if (isBlockAppt(app.appointmentData)) {
            <div style="background-color: orange; pointer-events: none; color: white; position: relative; width: 100%;"
              data-cy="scheduler-appointment-blocked">
              <div style="width: 100%; text-align: center; font-weight: 500;" data-cy="scheduler-appointment-blocked-header">
                @if (app.appointmentData.enumApptTypeId ==='00000071-0000-0000-0000-000000000005') {
                  <div data-cy="scheduler-appointment-blocked-out">
                    BLOCKED OUT
                  </div>
                }
                @if (app.appointmentData.enumApptTypeId =='00000071-0000-0000-0000-000000000006') {
                  <div data-cy="scheduler-appointment-blocked-in">
                    BLOCKED IN
                  </div>
                }
              </div>
              <div style="margin-top: 5px;" data-cy="scheduler-appointment-blocked-details">
                <div style="width: 100%; overflow-wrap: break-word; word-break: break-all;" data-cy="scheduler-appointment-blocked-subject">
                  {{app.appointmentData.Subject}}
                </div>
                <div style="width: 100%; overflow-wrap: break-word; word-break: break-all;" data-cy="scheduler-appointment-blocked-description">
                  {{app.appointmentData.Description}}
                </div>
              </div>
            </div>
          }
          @if (!isBlockAppt(app.appointmentData) && app.appointmentData.isReservation===false && !app.appointmentData.isBlockTime) {
            <div style="font-size: x-small; margin: 0; padding: 0" data-cy="scheduler-appointment-normal">
              <div class="appointment-layout-row" data-cy="scheduler-appointment-row">
                <div class="appointment-layout-column appointment-layout-right"
                  [style.background-color]="app.appointmentData?.AppointmentStatus_BackColor" [style.color]="app.appointmentData?.AppointmentStatus_ForeColor"
                  data-cy="scheduler-appointment-right">
                  <div (click)="onOpenMedicalInformationFormDialog(app.appointmentData);"
                    matTooltip="Appointment Medical Information"
                    data-cy="scheduler-appointment-medical-info">
                    <lucide-icon name="clipboard-list" [size]="20" style="width: 22px; height: 22px; color: #00a200" data-cy="scheduler-appointment-medical-icon"></lucide-icon>
                  </div>
                </div>
                <div class="appointment-layout-column appointment-layout-left" data-cy="scheduler-appointment-left">
                  <div class="header-class"
                    [style.background-color]="app.appointmentData?.AppointmentType_BackColor" [style.color]="app.appointmentData?.AppointmentType_ForeColor"
                    data-cy="scheduler-appointment-header"
                    >Flags:
                    @for (i of app.appointmentData.PatientFlagsEnums; track i) {
                      <div  >
                        <img class="appointment_flag" [src]="i.IconIDSVG" [matTooltip]="i.ItemDisplayValue" [alt]="i.ItemDisplayValue"/>
                      </div>
                    }
                    @for (i of app.appointmentData.AppointmentFlagsEnums; track i) {
                      <div  >
                        <img class="appointment_flag" [src]="i.IconIDSVG" [matTooltip]="i.ItemDisplayValue" [alt]="i.ItemDisplayValue"/>
                      </div>
                    }
                  </div>
                  <div class="left-content-class" [innerHTML]="getAppointmentLabel(app.appointmentData)"></div>
                </div>
              </div>
            </div>
          }
        </div>
      </dx-scheduler>
    }

    <dx-context-menu [dataSource]="rightClickAppointmentOptions" [width]="200" target=".dx-scheduler-appointment"
      (onItemClick)="ctxMenuItemClickApp($event)" (onShowing)="onAppContextMenuShowing($event)" [(visible)]="isAppContextMenuVisible">
    </dx-context-menu>
    <dx-context-menu [dataSource]="rightClickScheduleOptions" [width]="200" target=".dx-scheduler-date-table-cell"
      (onItemClick)="ctxMenuItemClickCell($event)" [(visible)]="isCellContextMenuVisible">
    </dx-context-menu>
  </div>
</div>
